/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The channel a requisition was created through. Decides which rules a requisition is held to:
 * only @see {@link Synqo.Cloud.Utilities.Enums.Orders.EnumRequisitionOrigin.Portal} requisitions belong to the requesting customer and may be shown as
 * their own submission, everything else was recorded on their behalf.
 */
export enum EnumRequisitionOrigin {
    /**
     * Submitted by the customer themselves, through the B2B portal or an equivalent customer-scoped API session.
     */
    Portal = 0,
    /**
     * Recorded by the operator on the customer's behalf, no matter which channel the customer used
     * to reach them (phone, mail, or walking up to the counter).
     */
    OperatorEntry = 1,
    /**
     * Imported from a third-party ERP that owns the order.
     */
    ExternalErp = 2,
}
